export class Apikey {
    constructor(id, label, enabled, createTime, lastUpdateTime, value) {
        this.id = id;
        this.label = label;
        this.enabled = enabled;
        this.createTime = createTime;
        this.lastUpdateTime = lastUpdateTime;
        this.value = value;
    }
}
export class ApikeyPatch {
    constructor(id, label = null, enabled = null) {
        this.id = id;
        this.label = label;
        this.enabled = enabled;
    }
}
export class NewApikey {
    constructor(label) {
        this.label = label;
    }
}
//# sourceMappingURL=ApikeyManager.js.map